// extracted by mini-css-extract-plugin
export default {"Wrapper":"WelcomeOperator_Wrapper__UydMd","Container":"WelcomeOperator_Container__MOcfb","Logo":"WelcomeOperator_Logo__5dutV"};